var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3StarR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 62,
    viewBox: "0 0 103 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9577 51.8835L26.7127 57.1676L24.3894 47.2085L32.1244 40.5076L21.9385 39.6293L17.9577 30.251L13.9768 39.6293L3.79102 40.5076L11.5118 47.2085L9.20268 57.1676L17.9577 51.8835Z",
    fill: "#FECC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9577 51.8835L94.7127 57.1676L92.3894 47.2085L100.124 40.5076L89.9385 39.6293L85.9577 30.251L81.9768 39.6293L71.791 40.5076L79.5118 47.2085L77.2027 57.1676L85.9577 51.8835Z",
    fill: "#FECC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9577 24.8835L60.7127 30.1676L58.3894 20.2085L66.1244 13.5076L55.9385 12.6293L51.9577 3.25098L47.9768 12.6293L37.791 13.5076L45.5118 20.2085L43.2027 30.1676L51.9577 24.8835Z",
    fill: "#FECC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3StarR);
export default __webpack_public_path__ + "static/media/3star-r.d2451c459c8084c3f740ef49884548c2.svg";
export { ForwardRef as ReactComponent };